import { Link } from "react-router-dom";
import { useState } from "react";
import { motion } from "motion/react";
import { ArrowUpRight } from "lucide-react";
import { formatEuro, formatKm } from "@/lib/api";
import FuelBadge from "@/components/FuelBadge";

export default function CarCard({ car, index = 0 }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/autot/${car.nettiauto_id}`}
        data-testid={`car-card-${car.nettiauto_id}`}
        className="group block border border-white/10 bg-[#121212] hover:border-[#ff5a00]/50 transition-colors duration-300"
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-[#0a0a0a]">
          {car.image ? (
            <img
              src={car.image}
              alt={car.title}
              loading="lazy"
              onLoad={() => setLoaded(true)}
              className={`w-full h-full object-cover transition-[transform,opacity] duration-700 ease-out group-hover:scale-105 ${loaded ? "opacity-100" : "opacity-0"}`}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-white/30 font-mono text-xs">EI KUVAA</div>
          )}
          <div className="absolute top-0 right-0 bg-[#ff5a00] text-white font-mono text-base md:text-lg font-medium px-4 py-2">
            {formatEuro(car.price)}
          </div>
        </div>
        <div className="p-6">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-display text-xl tracking-tight text-white group-hover:text-[#ff5a00] transition-colors duration-300">
              {car.title}
            </h3>
            <ArrowUpRight size={20} className="text-white/40 group-hover:text-[#ff5a00] transition-colors shrink-0" />
          </div>
          {car.mallitarkenne && (
            <p className="mt-1 font-mono text-xs text-[#ff5a00]/90">
              {car.mallitarkenne}
            </p>
          )}
          <div className="mt-4 flex items-center justify-between gap-3">
            <div className="flex gap-6 font-mono text-xs uppercase tracking-widest text-white">
              <span>{car.year || "—"}</span>
              <span>{formatKm(car.mileage)}</span>
            </div>
            <FuelBadge fuel={car.fuel} />
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
